/* eslint newline-before-return: "error" */
import { enableOrDisableCertification } from '../../Api/request/certification';
import UseAxios from '../../Api/http/http';
import {
  ENABLE_DISABLE_CERTIFI_DIALOG,
  ENABLE_DISABLE_ROLE_DIALOG,
  AUTHENTICATION_FAILED,
} from '../../Constants/strings';
import { STATUS_CODES } from '../../Api/resources/statusCodes';

export const handleDialogSubmit = async (
  data,
  setCertifications,
  setIsDialogOpen,
  handleSnackbar,
  setIsEdit,
) => {
  const { is_active, isActive, certification_id, id, last_updated_by } = data;
  const isActiveStatus = Number(is_active || isActive) ? 0 : 1;

  const certificationData = {
    certification_id: certification_id || id,
    is_active: isActiveStatus,
    last_updated_by,
  };

  try {
    const response = await UseAxios(enableOrDisableCertification(certificationData));
    const { status, response: responseData } = response.data;

    if (status !== STATUS_CODES.SUCCESS) {
      handleDialogClose(setIsDialogOpen, setIsEdit);
      let errorMessage = '';

      switch (responseData.status) {
      case STATUS_CODES.UNAUTHORIZED:
        errorMessage = AUTHENTICATION_FAILED;
        break;
      case STATUS_CODES.BAD_REQUEST:
        errorMessage = responseData.data.externalMessage;
        break;
      default:
        errorMessage = ENABLE_DISABLE_ROLE_DIALOG.OOPS_TRY_AGAIN;
      }

      handleSnackbar(errorMessage, 'warning', 'enable-disable-warning-snackbar');
      throw new Error('Failed to enable/disable certification');
    }

    setCertifications((prevRows) =>
      prevRows.map((row) => {
        if (certificationData.certification_id === row.id) {
          row.isActive = certificationData.is_active; // Update the isActive value of updated row
        }

        return row;
      }),
    );

    handleDialogClose(setIsDialogOpen, setIsEdit);
    const message = certificationData.is_active
      ? ENABLE_DISABLE_CERTIFI_DIALOG.ENABLE.RESPONSE_SUCCESS
      : ENABLE_DISABLE_CERTIFI_DIALOG.DISABLE.RESPONSE_SUCCESS;
    handleSnackbar(message, 'success', 'enable-disable-success-snackbar');
  } catch (error) {
    console.error('Error enabling/disabling certification:', error);
  }
};

export const handleDialogClose = (setIsDialogOpen, setIsEdit) => {
  setIsDialogOpen(false);
  setIsEdit(false);
};
